import React, { Component } from "react";

class About extends Component {
  render() {
    return (
      <div className="background-white">
        <div className="d-lg-flex">
          <div className="col-left">
            <div
              className="featured-post animate-element wow delay5 fadeInUp"
              data-wow-delay="0.5s"
            >
              <img src="/images/section/03.png" alt="images" />
            </div>
          </div>
          <div className="col-right">
            <div
              className="flat-spacer"
              data-desktop="105"
              data-mobile="50"
              data-smobile="50"
            ></div>
            <div className="flat-title t1">
              <div
                className="animate-element wow delay5 fadeInDown"
                data-wow-delay="0.5s"
              >
                <h4 className="sub-title mg-b22">About Me</h4>
                <h2 className="title-section mg-b26 color-d12">
                  Passionate Software developer and Engineer.
                 <h4 className="color-d4">My experience</h4>
                </h2>
              <p>
              Detail-oriented and results-driven developer with a strong foundation in cloud computing, 
              modern web technologies, and scalable application design. Certified AWS Cloud Practitioner 
              with proven expertise in building secure, cloud-native solutions and dynamic user interfaces 
              using React and .NET. Adept at transforming complex challenges into elegant, 
              efficient systems optimizing performance across full-stack environments. 
              I bring analytical rigor, creative energy, and a problem-solving mindset to every project. 
              Actively seeking opportunities to innovate and grow within forward-thinking tech teams.
              </p>
              </div>
              <div
                className="animate-element wow delay5 fadeInUp"
                data-wow-delay="0.5s"
              >
                <div className="fl-btn btn-general">
                  <a
                    href="https://www.linkedin.com/in/sara-uras-11619a166/"
                    className="f-w500 color-1 lt-sp07"
                  >
                    Hire Me
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default About;
